import { Link } from "react-router-dom"
import { PublicHeader, PublicFooter, PublicContact, usePublicLocale } from "../components/PublicLayout"

const SupportPage = () => {
  const { copy: { support, common }, localize } = usePublicLocale()
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <PublicHeader />
      <main className="public-document">
        <div className="public-document-lead">
          <p className="public-eyebrow">{support.eyebrow}</p>
          <h1>{support.title}</h1>
          <p>{support.description}</p>
        </div>
        <PublicContact title={support.contactTitle} description={support.contactDescription} />
        <section className="public-card">
          <h2>{support.faqTitle}</h2>
          <p>{support.faqDescription}</p>
        </section>
        {support.faqs.map(({ title, answer }) => (
          <section className="public-card" key={title}>
            <h2>{title}</h2>
            <p>{answer}</p>
          </section>
        ))}
        <Link to={localize("/legal/privacy-policy")}>{common.privacyLink}</Link>
        <PublicContact title={support.helpTitle} description={support.helpDescription} />
      </main>
      <PublicFooter />
    </div>
  )
}

export default SupportPage
